import { FormattedMessage } from 'react-intl';
import { Icon } from '@ets/design-system';
import styles from './NotFoundElement.module.scss';

const NotFoundElement = () => (
  <div className={styles.container}>
    <div className={styles.logoContainer}>
      <Icon icon="magnifying-glass" size="20" testId="not-found" color="primary" />
    </div>
    <div className={styles.text} data-testid="public-link-notfound-description">
      <FormattedMessage id="public.noLink.noLink1" />
      <br />
      <FormattedMessage id="public.noLink.noLink2" />
    </div>
  </div>
);

export default NotFoundElement;
